<template>
    <v-toolbar-items>
        <v-layout align-center>          
            <!-- <v-divider v-if="$vuetify.breakpoint.lgAndUp" vertical /> -->
            <v-icon v-if="$vuetify.breakpoint.smAndUp" id="user_icon" :style="'font-size:50px'">account_circle</v-icon>            
            <v-menu offset-y>
                <template v-slot:activator="{ on }">
                    <div class="roboto-bold-20 username hidden-md-and-down" v-on="on">{{user}}</div>
                </template>
                <!-- <v-list>
                    <v-list-item class="pointer"><v-list-item-title>Export to bookmarks</v-list-item-title></v-list-item>
                    <v-list-item class="pointer"><v-list-item-title>Import from bookmarks</v-list-item-title></v-list-item>
                </v-list>                 -->
            </v-menu>           
            <v-icon 
                class="ml-3 mr-xl-9 mr-lg-9 mr-md-9" 
                medium
                :color="'var(--cl-bg)'"
                @click.stop="openCloseMenu()"
            >
                mdi-dots-vertical
            </v-icon>
            <div v-click-outside="closeMenu">
                <div class="absolute menu pointer" v-show="menu">
                    <div class="flex-center-between mt-4 ml-6" @click="toFeeds()" v-if="$vuetify.breakpoint.xs">
                        <div class="roboto-normal-16 clr-black-38">Добавить заметку</div>
                        <img class="mr-5" height="18px" src="./../../assets/images/header/notice.svg">
                    </div>
                    <div class="border mt-3" v-if="$vuetify.breakpoint.xs"></div>
                    <div class="flex-center-between mt-4 ml-6" @click="toSearch()" v-if="$vuetify.breakpoint.xs">
                        <div class="roboto-normal-16 clr-black-38">Поиск</div>
                        <img class="mr-5" height="18px" src="./../../assets/images/header/magnify.svg">
                    </div>
                    <div class="border mt-3" v-if="$vuetify.breakpoint.xs"></div>
                    <div class="flex-center-between mt-4 ml-6" @click="toThemes()" v-if="$vuetify.breakpoint.xs">
                        <div class="roboto-normal-16 clr-black-38">Настройки раздела</div>
                        <img class="mr-5" height="18px" src="./../../assets/images/header/folder.svg">
                    </div>
                    <div class="border mt-3" v-if="$vuetify.breakpoint.xs"></div>
                    <div class="flex-center-between mt-4 ml-6" @click="toFeeds()" v-if="$vuetify.breakpoint.xs">
                        <div class="roboto-normal-16 clr-black-38">Лента</div>
                        <img class="mr-5" height="18px" src="./../../assets/images/header/feed.svg">
                    </div>
                    <div class="border mt-3" v-if="$vuetify.breakpoint.xs"></div>
                    <!-- <div class="flex-center-between mt-4 ml-6">
                        <div class="roboto-normal-16 clr-black-38">Настройки</div>
                        <img class="mr-5" height="18px" src="./../../assets/images/header/settings.svg">
                    </div>
                    <div class="border mt-3"></div> -->
                    <div class="flex-center-between mt-4 ml-6 mb-4" @click="($router.push('/learn'), menu = false, menuSecondary = false)">
                        <div class="roboto-normal-16 clr-black-38">Обучение</div>
                        <v-icon color="grey" size="18" class="mr-5">mdi-school</v-icon>
                    </div>
                    <div class="border mt-3" v-if="$vuetify.breakpoint.xs"></div>
                    <div class="flex-center-between mt-4 ml-6 mb-4" @click="logout">
                        <div class="roboto-normal-16 clr-black-38">Выход</div>
                        <img class="mr-5" height="18px" src="./../../assets/images/header/exit.svg">
                    </div>
                </div>
                <div class="absolute menu-secondary pointer" v-show="menuSecondary">
                    <div class="flex-center-between mt-4 ml-6" @click="renameTheme()" v-if="$vuetify.breakpoint.xs">
                        <div class="roboto-normal-16 clr-black-38">Редактировать</div>
                    </div>
                    <div class="border mt-3" v-if="$vuetify.breakpoint.xs"></div>
                    <DeleteItem :themeMobile="true" @deleteItem="deleteTheme()" v-if="$vuetify.breakpoint.xs"/>
                </div>
            </div>
            <!-- <v-menu offset-y v-if="$vuetify.breakpoint.smOnly">
                <template v-slot:activator="{ on }">
                    <div class="username" v-on="on">{{user}}</div>
                </template>
                <v-list>
                    <v-list-item @click="logout"><v-list-item-title>Log out</v-list-item-title></v-list-item>
                </v-list>                
            </v-menu> -->
            <!-- <v-divider id="divider_user" v-if="$vuetify.breakpoint.smAndUp" vertical />             -->
        </v-layout>
    </v-toolbar-items>
</template>

<script>
    import { mapActions, mapGetters, mapMutations } from 'vuex'
    import DeleteItem from './../popups/DeleteItem'
    import ClickOutside from 'vue-click-outside'
    export default {
        name: 'ToolbarItems',
        components:{
            DeleteItem
        },
        data: () => ({
            languages: ['Ru', 'En'],
            menu: false,
            menuSecondary: false,
        }),        
        computed:{
            ...mapGetters(['current', 'feeds', 'theme', 'themes', 'language', 'user']),
        },
        methods:{
            logout(){
                this.logOut().then(() => {
                    // this.OPEN_POPUP('Start')
                    // this.$router.push("/start")
                    this.$router.push("/login")
                })
            },
            toFeeds() {
                this.$router.push("/feeds")
                this.$root.$emit('selectElementMenu')
                this.menu = false
                this.menuSecondary = false
            },
            toThemes() {
                this.menuSecondary = !this.menuSecondary
            },
            toSearch() {
                this.$root.$emit('closeMobileTheme')
                this.$root.$emit('closeMobileTask')
                this.$root.$emit('search')
                this.menu = false
                this.menuSecondary = false
            },
            renameTheme() {
                this.$root.$emit('renameMobileTheme')
                this.$router.push("/theme")
                this.$root.$emit('selectElementMenu')
                this.menu = false
                this.menuSecondary = false
            },
            deleteTheme() {
                this.delTheme(this.current._id).then(() => {
                    // this.rename_flag = false
                    const themes_id = this.themes.map(item => item._id)
                    this.saveOrderThemes(themes_id)
                    // if(this.current._id == this.theme._id){
                    this.$store.commit('SET_CURRENT', this.themes[0])
                    // this.$router.push('/')
                    // }
                    this.$router.push("/theme")
                    this.$root.$emit('selectElementMenu')
                    this.menu = false
                    this.menuSecondary = false
                    this.$root.$emit('deleteMobileTheme')
                })
            },
            openCloseMenu() {
                this.menu = !this.menu
            },
            closeMenu() {
                this.menu = false
                this.menuSecondary = false
            },
            ...mapActions([
                'logOut', 'delTheme', 'saveOrderThemes'
            ]),
            ...mapMutations(['OPEN_POPUP', 'SET_CURRENT'])
        },
        directives: {
            ClickOutside
        }
    }
</script>

<style lang="scss" scoped>
    #header_top.theme--light{
        background: aliceblue;
        box-shadow: none;
    }
    .header_switch{
        margin-top: 5% !important;        
        margin-right: 15px !important;
        margin-left: 20px !important;
    }
    .username{
        margin-left: 5px !important;
    }
    #user_icon{
        margin-left: 15px !important;
    }
    #divider_user{
        margin-left: 15px !important;
    }
    .logout{
        margin-right: 0px !important;
    }
    .menu {
        top:82px;
        right:2%;
        width:231px;
        height:auto;
        background: #F2F2F2;
        border-radius: 16px;
        z-index:99;
        .border {
            border:1px solid #D6D6D6;
            width:231px;
        }
    }
    .menu-secondary {
        top:133px;
        right:15%;
        width:231px;
        height:auto;
        background: #F2F2F2;
        border-radius: 16px;
        z-index:100;
        .border {
            border:1px solid #D6D6D6;
            width:231px;
        }
    }
</style>

<style>
    .select_feed .v-label--active{
        display: none !important; 
    }
</style>